import markItemsJunkNotJunkBasedOnItemIds from './markItemsJunkNotJunkBasedOnItemIds';
import createItemContextsForDeleteStoreUpdate from '../helpers/createItemContextsForDeleteStoreUpdate';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import mailStore from 'owa-mail-store/lib/store/Store';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';

export interface MarkItemJunkNotJunkFromReadingPaneState {
    item: ClientItem;
}

/**
 * Mark item as junk/not junk
 * @param itemIds the specified item Ids to be marked as junk
 * @param actionSource the source that initiated the action
 * @param state the MarkItemJunkNotJunkFromReadingPaneState which contains the original table view
 */
export default function markItemJunkNotJunkFromReadingPane(
    itemId: string,
    tableView: TableView,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    state: MarkItemJunkNotJunkFromReadingPaneState = { item: mailStore.items.get(itemId) }
) {
    const item = state.item;
    const isJunkFolder = doesFolderIdEqualName(item.ParentFolderId.Id, 'junkemail');
    return markItemsJunkNotJunkBasedOnItemIds(
        [itemId],
        !isJunkFolder /* isJunkValueToSet*/,
        actionSource,
        tableView,
        instrumentationContexts,
        () => {
            const itemContexts = createItemContextsForDeleteStoreUpdate([itemId]);
            // Dispatch action to update the store state
            deleteItemsStoreUpdate(itemContexts, item.ParentFolderId.Id, 'MarkAsJunk');
        }
    );
}
